import { render, staticRenderFns } from "./ImportantNoticePopup.vue?vue&type=template&id=f6b52e46&scoped=true&"
import script from "./ImportantNoticePopup.vue?vue&type=script&lang=js&"
export * from "./ImportantNoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./ImportantNoticePopup.vue?vue&type=style&index=0&id=f6b52e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b52e46",
  null
  
)

export default component.exports